export default "__VITE_ASSET__BuV9DPsi__"